import React, { Component } from 'react'
import { RedirectIcon } from 'pdc-svg-icons'

import { withStyles } from '@material-ui/core'
import PDCButton from 'pdc-button';

import NumberSearchApp from 'embedded-custom-number-search';

const styles = theme => ({
	addANumberWrapper: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: 15,
		fontWeight: 600,
		width: '100%',
		height: '100%',
		// padding:		50

		overflow: 'hidden'
	},
	selectPickerWrapper: {
		maxWidth: '960px',
		['@media (min-width:1500px)']: {
			maxWidth: 'none',
			padding: '0px 75px',
		},
		margin: 'auto',
		marginTop: '50px',
		borderBottom: '1px solid #eee',
		[theme.breakpoints.down('sm')]: {
			display: 'flex',
			marginTop: '15px',
		}
	},
	pickerOption: {
		textAlign: 'center',
		padding: '5px 20px',
		display: 'inline-block',
		color: '#85929A',
		fontSize: '14px',
		cursor: 'pointer',
		"&:hover": {
			color: "#3FAE29"
		},
		[theme.breakpoints.down('sm')]: {
			margin: 'auto'
		},
		'&.loading': {
			cursor: 'wait',
			"&:hover": {
				color: "#85929A"
			},
		}
	},
	row: {
		marginBottom: 15,
		'& .number': {
			fontSize: 30,
			marginRight: 25,
		},
		'& .greenText': {
			color: theme.palette.primary[0]
		},
		'& .redirect': {
			cursor: 'pointer'
		}
	}
})

class MyNumbers extends Component {

	state = {
		searchType: 'local_nonvanity',
		showHeaders: true,
		numberSearchLoading: true
	}

	toggleHeaders = (show) => {
		this.setState({showHeaders: show});
	}

	redirectToCP = () => {
		const cfg 		= window.APP_CONFIG
		const cpBase	= cfg.cpBase
		window.open(`${cpBase}/voip/add_number`, '_blank')
	}

	numberSearchLoading = (isLoading) => {
		this.setState({numberSearchLoading: isLoading})
	}

	setSearchType = searchType => !this.state.numberSearchLoading ? this.setState({searchType}) : null
	

	render() {
		const { classes }	= this.props

		if (!process.env.REACT_APP_ADD_A_NUMBER) {
			return (
				<div className={classes.addANumberWrapper}>
					<div className={classes.row}>
						To add a number to your account, follow these steps:
					</div>
					<div className={classes.row}>
						<span className='number'>1.</span>Get a number using our advanced-mode
						<span className='redirect' onClick={this.redirectToCP}>
							<span className='greenText'> control panel <RedirectIcon/></span>
						</span>
					</div>
					<div className={classes.row}>
						<span className='number'>2.</span>Then come back here and navigate to
						<span className='redirect' onClick={() => document.getElementById("header-tab-my-numbers").click()}>
							<span className='greenText'> My Numbers <RedirectIcon/></span>
						</span>
					</div>
					<div className={classes.row}>
						<span className='number'>3.</span>And configure your number (use the 3 dot menu)
					</div>
					<div className={classes.row}>
						<span className='number'>4.</span>Test your new number by calling it
					</div>
					<div className={classes.row}>
						Need help? Contact / call our support line. Click the ? icon.
					</div>
				</div>
			)
		}

		return (
			<div className={classes.addANumberWrapper}>
				{this.state.showHeaders && (<div style={{padding: '0px 20px'}}>
					<div className={classes.selectPickerWrapper}>
						<div className={`${classes.pickerOption} ${this.state.numberSearchLoading ? 'loading' : ''}`}
							data-search-tab='local_nonvanity'
							style={this.state.searchType == 'local_nonvanity' ? 
								{borderBottom: '2px solid #48B9D5', color: 'black'} : {}}
							onClick={() => this.setSearchType('local_nonvanity')}>
								Local
						</div>
						<div className={`${classes.pickerOption} ${this.state.numberSearchLoading ? 'loading' : ''}`}
							data-search-tab='tollfree_nonvanity'
							style={this.state.searchType == 'tollfree_nonvanity' ? 
								{borderBottom: '2px solid #48B9D5', color: 'black'} : {}}
							onClick={() => this.setSearchType('tollfree_nonvanity')}>
								Toll free
						</div>
						<div className={`${classes.pickerOption} ${this.state.numberSearchLoading ? 'loading' : ''}`}
							data-search-tab='vanity'
							style={this.state.searchType == 'vanity'? 
								{borderBottom: '2px solid #48B9D5', color: 'black'} : {}}
							onClick={() => this.setSearchType('vanity')}>
								Personalized 
						</div>
					</div>
				</div>)}
				{this.state.searchType == 'vanity' && <NumberSearchApp setLoading={this.numberSearchLoading} toggleHeaders={this.toggleHeaders} switchTab={this.props.switchTab} source={"control_panel"} mode={"vanity"}/>}
				{this.state.searchType == 'tollfree_nonvanity' && <NumberSearchApp setLoading={this.numberSearchLoading} toggleHeaders={this.toggleHeaders} switchTab={this.props.switchTab} source={"control_panel"} mode={"tollfree_nonvanity"}/>}
				{this.state.searchType == 'local_nonvanity' && <NumberSearchApp setLoading={this.numberSearchLoading} toggleHeaders={this.toggleHeaders} switchTab={this.props.switchTab} source={"control_panel"} mode={"local_nonvanity"}/>}
			</div>
		)
	}
}

export default withStyles(styles)(MyNumbers)